import { render, staticRenderFns } from "./RewardsTable.vue?vue&type=template&id=23ebef04&scoped=true"
import script from "./RewardsTable.vue?vue&type=script&lang=js"
export * from "./RewardsTable.vue?vue&type=script&lang=js"
import style0 from "./RewardsTable.vue?vue&type=style&index=0&id=23ebef04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ebef04",
  null
  
)

export default component.exports